

















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import CidadeModel from "@/models/cadastros/saude/CidadeModel";
import { saudeCidadeService } from "@/service/cadastro/saude/cidade/SaudeCidadeService";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { estadosList } from "@/models/commons/EstadoModel";

@Component({
  components: {
    ValidationObserver,
    MessageDialog,
  },
})
export default class CadastroEspecialidade extends Vue {
  $refs!: {
    cadastroObserver: InstanceType<typeof ValidationObserver>;
  };

  cidade = {};

  estados = estadosList;

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogType = "";
  dialogKey = 0;
  dialog = false;

  mounted() {
    this.loadInfo();
  }

  loadInfo() {
    if (this.$route.params.idCidade) {
      saudeCidadeService
        .obterPorId(new Number(this.$route.params.idCidade))
        .then((res) => {
          this.cidade = {
            id: res.id,
            nome: res.nome,
            estado: this.estados?.find(
              (estado) => estado?.sigla == res?.estado
            ),
          };
        });
    }
  }

  acaoDialog(tipo: string) {
    if (tipo == "sucesso") {
      this.$router.push({ name: "ListaCidades" });
    } else {
      this.openDialog = false;
    }
  }

  gravar() {
    this.$refs.cadastroObserver.validate().then((valid) => {
      if (valid) {
        if (this.$route.params.idCidade) {
          saudeCidadeService
            .atualizar(this.cidade, new Number(this.$route.params.idCidade))
            .then((res: any) => {
              this.dialogTitle = "Alteração realizada com sucesso";
              this.dialogMessage = "Alteração realizada com sucesso";
              this.dialogStyle = "success";
              this.dialogType = "sucesso";
              this.openDialog = true;
            })
            .catch((err: any) => {
              this.dialogTitle = err;
              this.dialogMessage = err;
              this.dialogStyle = "error";
              this.dialogType = "";
              this.openDialog = true;
            });
        } else {
          saudeCidadeService
            .salvar(this.cidade)
            .then((res) => {
              this.dialogTitle = "Cadastro de cidade realizado com sucesso";
              this.dialogMessage = "Cadastro de cidade realizado com sucesso";
              this.dialogStyle = "success";
              this.dialogType = "sucesso";
              this.openDialog = true;
            })
            .catch((err) => {
              this.dialogTitle = err;
              this.dialogMessage = err;
              this.dialogStyle = "error";
              this.dialogType = "";
              this.openDialog = true;
            });
        }
      }
    });
  }
}
